export default __webpack_public_path__ + "static/MenuPositioning2_x2-a69db4650e0ac3b7d32b81bec232d78d.png";